import React, { forwardRef } from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './icon-button.style';
import { Colors, Sizes, Variants } from './types';

export type IconButtonProps = React.ComponentProps<'button'> & {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  variant?: Variants;
  size?: Sizes;
  rotation?: number;
  as?: string;
  preventDrag?: boolean;
  highlighted?: boolean;
  noHover?: boolean;
  color?: Colors;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      variant = Variants.Contained,
      size = Sizes.Medium,
      color = Colors.Inherit,
      rotation,
      preventDrag,
      highlighted,
      noHover,
      ...rest
    },
    ref,
  ) => (
    <Styled.Button
      {...rest}
      $variant={variant}
      $color={color}
      $size={size}
      $preventDrag={!!preventDrag}
      $hasHover={!noHover}
      $highlighted={!!highlighted}
      ref={ref}
    >
      <Styled.IconContainer $rotation={rotation}>
        <Icon icon={icon} />
      </Styled.IconContainer>
    </Styled.Button>
  ),
);
